import { Component, Input } from '@angular/core';

export interface StatTileData {
  label: string;
  value: string;
  caption: string;
  deltaPct: number;
  trend: 'up' | 'down' | 'flat';
  isImprovement: boolean;
  series: number[];
}

@Component({
  selector: 'app-stat-tile',
  standalone: false,
  templateUrl: './stat-tile.html',
})
export class StatTile {
  @Input({ required: true }) stat!: StatTileData;
}
